import { render, staticRenderFns } from "./HeaderArbitrator.vue?vue&type=template&id=88f39e7a&scoped=true&"
import script from "./HeaderArbitrator.vue?vue&type=script&lang=js&"
export * from "./HeaderArbitrator.vue?vue&type=script&lang=js&"
import style0 from "./HeaderArbitrator.vue?vue&type=style&index=0&id=88f39e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f39e7a",
  null
  
)

export default component.exports